<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">Income tax</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">22,643</td>
                            <td class="end font">24,949</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Other levies</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">463</td>
                            <td class="end font">304</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">23,106</td>
                            <td class="end font white font-weight-bold">25,253</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">ضريبة الدخل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">22,643</td>
                            <td class="end font">24,949</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">ضرائب أخرى</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">463</td>
                            <td class="end font">304</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">23,106</td>
                            <td class="end font white font-weight-bold">25,253</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>